import BrazilFlag from './brazil-flag.svg'
import USAFlag from './usa-flag.svg'
import CSSIcon from './css.png'
import HTMLIcon from './html.png'
import JavascriptIcon from './jscript.png'
import NextJsIcon from './next.png'
import ReactJsIcon from './reactjs.png'
import ReduxIcon from './redux.png'
import SassIcon from './sass.png'
import StyledComponentsIcon from './styled.png'
import TypescriptIcon from './typescript.png'
import PortfolioFirstImage from './portfolio.jpg'
import PortfolioSecondImage from './portfolio2.jpg'
import MazeCarImage from './mazecars.jpg'
import MazeMotorcycleImage from './mazemotorcycle.jpg'
import TalwindCssIcon from './tailwind-css.jpg'
import ElectronIcon from './electron.svg'
import ZustandIcon from './zustand.jpeg'

export const IMAGES = {
    BRAZIL_FLAG: {
        alt: 'Brazilian Flag',
        image: BrazilFlag
    },
    USA_FLAG: {
        alt: 'USA Flag',
        image: USAFlag
    },
    ELECTRON_ICON: {
        alt: 'Electron',
        image: ElectronIcon,    
    },
    ZUSTAND_ICON: {
        alt: 'Zustand',
        image: ZustandIcon,    
    },
    CSS_ICON: {
        alt: 'CSS',
        image: CSSIcon,
    },
    HTML_ICON: {
        alt: 'HTML',
        image: HTMLIcon
    },
    JAVASCRIPT_ICON: {
        alt: 'Javascript',
        image: JavascriptIcon
    },
    NEXTJS_ICON: {
        alt: 'NextJS',
        image: NextJsIcon
    },
    REACTJS_ICON: {
        alt: 'ReactJS',
        image: ReactJsIcon
    },
    REDUX_ICON: {
        alt: 'Redux',
        image: ReduxIcon
    },
    SASS_ICON: {
        alt: 'SASS',
        image: SassIcon
    },
    STYLED_COMPONENTS_ICON: {
        alt: 'Styled Components',
        image: StyledComponentsIcon
    },
    TAILWIND_CSS_ICON: {
        alt: 'Tailwind CSS',
        image: TalwindCssIcon
    },
    TYPESCRIPT_ICON: {
        alt: 'Typescript',
        image: TypescriptIcon
    },
    PORTFOLIO_FIRST_IMAGE: {
        alt: 'Portfolio Project',
        image: PortfolioFirstImage
    },
    PORTFOLIO_SECOND_IMAGE: {
        alt: 'Portfolio Project',
        image: PortfolioSecondImage
    },
    MAZE_CARS_IMAGE: {
        alt: 'Maze Car Project',
        image: MazeCarImage
    },
    MAZE_MOTORCYCLE_IMAGE: {
        alt: 'Maze Motorcycle Project',
        image: MazeMotorcycleImage
    }
}